export default [
    {
        id: 1,
        name_ca: 'Bona',
        name_en: 'Good',
        name_es: 'Buena'
    },
    {
        id: 2,
        name_ca: 'Correcta',
        name_en: 'Correct',
        name_es: 'Correcta'
    },
    {
        id: 3,
        name_ca: 'Difícil',
        name_en: 'Difficult',
        name_es: 'Difícil'
    }
]



// WEBPACK FOOTER //
// ./src/options/accessibility_types.js